export default "__VITE_ASSET__Cmgna8aS__"